/**
 * @desc 产品BOM-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductBomResponseDto>
>;
export function request(
  params: API.basics.productBom.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBom/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
